<script setup lang="ts">
import { customElementPropsKey } from '@/types/customElementProps.types'
import { computed, inject, ref } from 'vue'
import GenericMessage from './GenericMessage.vue'

const props = defineProps<{
  title: string
  subtitle?: string
  hideGenericMessage?: boolean
}>()
const templateProps = inject(customElementPropsKey)
const useFallbackLogo = ref(false)

const fallbackLogo = computed(
  () => `${templateProps?.resourcesPath}/img/sm-generic-icon-192x192.png`,
)
const logo = computed(() => {
  return templateProps?.baseUrl && !useFallbackLogo.value
    ? `${templateProps.baseUrl}/public/network-logo`
    : fallbackLogo.value
})
</script>

<template>
  <div class="d-flex flex-column align-stretch mb-6">
    <div class="d-flex justify-center">
      <v-img
        :src="logo"
        :height="72"
        :width="72"
        @error="useFallbackLogo = true"
        class="mb-6"
      />
    </div>
    <h1 class="text-center page-title">{{ props.title }}</h1>
    <p class="mt-2 text-body-2 text-center text-pre-wrap" v-if="props.subtitle">
      {{ props.subtitle }}
    </p>
    <GenericMessage
      v-if="!hideGenericMessage"
      data-cy="generic-message"
    />
  </div>
</template>

<style lang="css" scoped>
.page-title {
  line-height: 32px;
}
</style>
